import LogoContentBlock from "./functional";
export default LogoContentBlock;
